<template>
    <h1 v-translate>Zapomenuté heslo</h1>
</template>

<script>
	export default {
		name: "forgotten-password"
	}
</script>


// WEBPACK FOOTER //
// src/components/ForgottenPassword.vue